module.exports = __webpack_public_path__ + "static/media/minoan_preview.21f8b712.png";